// Shared by the report card on /new-report and the filter bar on the results
// page, so the two lists cannot drift apart. Values mirror
// DonationRefund.STATUS_CHOICES / COMPLETION_STATUS_CHOICES — the refund-audit
// endpoint rejects anything else with a 400.
export interface RefundAuditOption {
    value: string;
    label: string;
}

export const STATUS_OPTIONS: RefundAuditOption[] = [
    { value: 'succeeded', label: 'Succeeded' },
    { value: 'pending', label: 'Pending' },
    { value: 'failed', label: 'Failed' },
];

export const COMPLETION_OPTIONS: RefundAuditOption[] = [
    { value: 'complete', label: 'Entered' },
    { value: 'pending', label: 'Not entered' },
];

/** Previous calendar month — the range the endpoint falls back to when the
 *  request carries no dates. */
export const previousMonthDefaults = (): { from: string; to: string } => {
    const today = new Date();
    const firstOfThisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastOfLastMonth = new Date(firstOfThisMonth.getTime() - 86400000);
    const firstOfLastMonth = new Date(
        lastOfLastMonth.getFullYear(),
        lastOfLastMonth.getMonth(),
        1,
    );
    const fmt = (d: Date) =>
        `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
            d.getDate(),
        ).padStart(2, '0')}`;
    return { from: fmt(firstOfLastMonth), to: fmt(lastOfLastMonth) };
};
